import { BoloQueueView } from '@mark43/cad-api';
import { Flex, VStack, Text, Box, DataList, DataItem } from '@cad-arc';
import { BoloQueuePriorityChip } from '../fr-priority-chip';
import { FrQueueRowWrapper } from '../fr-queue-row-wrapper';
import { TruncatedBoloLabels } from '../../bolos/bolo-queues/components/cells/bolo-labels-cell';
import { observer } from 'mobx-react-lite';
import { useOpenFrBoloDetails } from './use-open-fr-bolo-details';
import { TextWithEllipsisAndTooltip } from '../../common/components/text-with-ellipsis-and-tooltip';

interface FrBoloQueueRowProps {
    data: BoloQueueView;
    isFirstRow?: boolean;
}

export const FrBoloQueueRow = observer(({ data, isFirstRow }: FrBoloQueueRowProps) => {
    const openBoloDetails = useOpenFrBoloDetails();
    return (
        <FrQueueRowWrapper
            isFirstRow={isFirstRow}
            leftChildren={
                <>
                    <BoloQueuePriorityChip data={data} />
                    <Flex alignItems="center">
                        <VStack alignItems="left">
                            <Text variant="headingMd">{data.primarySubjectShortDisplay}</Text>
                            <Text variant="bodyMd">{data.boloType.label}</Text>
                        </VStack>
                    </Flex>
                </>
            }
            onClickRightChildrenAction={() => openBoloDetails(data.id)}
            onClickLeftChildrenAction={() => openBoloDetails(data.id)}
            rightChildren={
                <VStack w="100%" alignItems="left" h="100%" justifyContent="center">
                    <DataList direction="row" wrap="wrap">
                        <DataItem dataKey="Subject">{data.primarySubjectDisplay}</DataItem>
                        <DataItem dataKey="Subject Notes">{data.primarySubjectNotes}</DataItem>
                    </DataList>

                    {!!data.labels.length && (
                        <DataList direction="row" wrap="wrap">
                            <TruncatedBoloLabels labels={data.labels} />
                        </DataList>
                    )}

                    <DataList direction="row" wrap="wrap">
                        <DataItem
                            dataKey={<Box whiteSpace="nowrap">D-Area</Box>}
                            style={{
                                marginLeft: 'inherit',
                                paddingRight: '10px',
                                width: `clamp(15%, ${Math.max(
                                    15,
                                    Math.min(
                                        35,
                                        data.dispatchAreas
                                            .map((dispatchArea) => dispatchArea.label)
                                            .join(' ').length * 0.8
                                    )
                                )}%, 50%)`,
                            }}
                        >
                            <TextWithEllipsisAndTooltip
                                text={
                                    data.dispatchAreas
                                        .map((dispatchArea) => dispatchArea.label)
                                        .join(' ') ?? '--'
                                }
                            />
                        </DataItem>
                        <DataItem
                            dataKey={<Box whiteSpace="nowrap">Subdivision</Box>}
                            style={{
                                marginLeft: 'inherit',
                                width: `clamp(15%, ${Math.max(
                                    15,
                                    Math.min(
                                        35,
                                        data.subdivisions
                                            .map((subdivision) => subdivision.label)
                                            .join(' ').length * 0.8
                                    )
                                )}%, 50%)`,
                            }}
                        >
                            <TextWithEllipsisAndTooltip
                                text={
                                    data.subdivisions
                                        .map((subdivision) => subdivision.label)
                                        .join(' ') ?? '--'
                                }
                            />
                        </DataItem>
                    </DataList>
                </VStack>
            }
        />
    );
});
